import api from '../../api/vo2api'


import BaseEntity from './BaseEntity';
let baseEntity = new BaseEntity({

    getEntityType() {
        return 'organizationUserAccount';
    },

    getEmptyName() {
        return '(empty name)'
    },

    getById(orgId, id) {
        return api.getOrganizationUserAccount(orgId, id)
    },

    getItems(orgId) {
        return api.getOrganizationUserAccountList(orgId)
    },

    getEntityId(entity) {
        if(entity) {
            return entity.userAccountId;
        }
        return null
    },

    augmentEntity( base, entity ) {
        if(entity) {
            if(entity.userAccount) {
                entity.userAccount.name = entity.userAccount.firstName + ' ' + entity.userAccount.lastName
            }
        }
        return entity
    }
});

const state = {
    ...baseEntity.state,
};
const getters = {
    ...baseEntity.getters,
};
const actions = {
    ...baseEntity.actions,

    inviteUser({ commit }, {organizationId, emailAddress, admin, notify}) {

        return api.inviteUser(organizationId, emailAddress, admin, notify)
                .then(function(success) {
                    if(success) {
                        commit('setItemsDirty', true )
                    }
                    return success;
                });
    },

    removeUser({ commit }, {organizationId, userId, notify}) {

        if(organizationId && userId) {
            commit('setCurrentLoading', true);
            return api.removeUser(organizationId, userId, notify)
                .then(function (success) {
                    if (success) {
                        commit('setCurrent', {});
                        commit('setItemsDirty', true)
                    }
                    return success;
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                    return false
                }).then(value => {
                    commit('setCurrentLoading', false);
                    commit('setCurrentDirty', false);
                    return value
                });
        }
    },

};
const mutations = {
    ...baseEntity.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};